module.exports = "/images/avatar-2.jpg?64b31693eb431ddea8916472de1ea9a9";